import { CSSObject } from "@emotion/react";

export const bottomActionsWrapperCss: CSSObject = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  margin: "0 1rem",
};
